var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdpTabExpandableContent',{attrs:{"headline":_vm.$t('pdp-tab-hints.headline')}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$t(`pdp-tab-hints.content.${_vm.articleType}`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }